<template>
    <div v-if="visibility">
        <div class="form-group border-top">
            <label class="light-text pt-3" for="" :class="required">{{option.label}}</label>
            <br>
            <div class="form-check form-check-inline" v-for="(field, key) in proxyFields" :key="key">
                <input
                    :required="required" 
                    type="radio" 
                    class="form-check-input" 
                    :value="field.value" 
                    :name="option.label" 
                    v-model="response" 
                    @change="handleResponse">
                <label class="form-check-label" for="">{{field.title}}</label>
            </div>
        </div>
    </div>
</template>
<script>
import {visibility, fields, props, data, required, handleResponse} from '@mixins/custom-options'
export default {
    mixins: [visibility, fields, props, data, required, handleResponse]
}
</script>